// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"208b49c4","233":"ef927419","278":"e3eb22ee","453":"670e15c7","507":"3a47b540","874":"32e23b9d","897":"bffa5c21"}[chunkId] + ".chunk.js";
};